import React, { Component } from "react";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
class NoteCard extends Component {
  static defaultProps = {
    name: "",
    noteActive: false,
    renderInputField: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      noteActive: this.props.noteActive,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.noteActive !== this.props.noteActive) {
      this.setState({ noteActive: this.props.noteActive });
    }
  }

  changeNoteStatus = () => {
    this.setState({ noteActive: !this.state.noteActive });
  };

  render() {
    return (
      <div className="card__bodyHeader">
        <h2
          className="font"
          onClick={() => this.changeNoteStatus()}
        >
          <i className={`fa-solid fa-square-chevron-${this.props.noteActive ? "down" : "right"}`} />
          {`Notes ${this.props.value[this.props.name] ? "!" : ""}`}
        </h2>
        {
          //prettier-ignore
          this.state.noteActive
            ? this.props.renderInputField(this.props.name, "", "", InputTypesEnum.TextBox2, null, "",false, [],  [], "textbox-group")
            : null
        }
      </div>
    );
  }
}

export default NoteCard;
